<template>
  <NCollapseTransition v-bind="mergedAttrs">
    <slot></slot>
  </NCollapseTransition>
</template>

<script lang="ts" setup>
import type { CollapseTransitionProps } from 'naive-ui'
import { NCollapseTransition } from 'naive-ui'
import { merge } from 'lodash-es'
import { useAttrs } from 'vue'

const attrs: CollapseTransitionProps = useAttrs()

const defaultAttrs: CollapseTransitionProps = {}

const mergedAttrs: CollapseTransitionProps = merge(defaultAttrs, attrs)
</script>
